import { createFileRoute } from '@tanstack/react-router';

import { MyPractitionerLayout } from '@/features/practitioners/components/shared/MyPractitionerLayout';
import { PractitionerDetailScreen } from '@/features/practitioners/components/shared/PractitionerDetailScreen';

export const Route = createFileRoute('/app/profile/')({
  component: ClinicalMyProfileScreen,
  staticData: { crumb: 'My profile' },
});

function ClinicalMyProfileScreen() {
  return (
    <MyPractitionerLayout>
      {(practitionerId) => (
        <PractitionerDetailScreen practitionerId={practitionerId} surface="clinical" />
      )}
    </MyPractitionerLayout>
  );
}
